const SET_SALE_ORDERS = "SET_SALE_ORDERS";

export { SET_SALE_ORDERS };
